import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { HttpInterceptorProvider } from './http-interceptor/http-interceptor';
import { NgModule } from '@angular/core';
import { MessageFactory } from '../app/factories/message.factory';
import { ApiServiceProvider } from './api-service/api-service';
import { ProfileServiceProvider } from './profile-service/profile-service';
import { LocalStorageServiceProvider } from './local-storage-service/local-storage-service';
import { StorageServiceProvider } from './storage-service/storage-service';
import { RequestServiceProvider } from './request-service/request-service';
import { InterestsServiceProvider } from './interests-service/interests-service';
import { PaymentServiceProvider } from './payment-service/payment-service';
import { LoaderServiceProvider } from './loader-service/loader-service';
import { BalanceServiceProvider } from './balance-service/balance-service';
import { UtilsServiceProvider } from './utils-service/utils-service';
import { ToastServiceProvider } from './toast-service/toast-service';
import { CheckoutServiceProvider } from './checkout-service/checkout-service';
import { ShareServiceProvider } from './share-service/share-service';
import { FtueServiceProvider } from './ftue-service/ftue-service';
import { FacebookServiceProvider } from './facebook-service/facebook-service';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { FirebaseServiceProvider } from './firebase-service/firebase-service';
import { AngularFireModule } from '@angular/fire';
import { AppSettings } from '../app/app.settings';
// import 'firebase/messaging'; // only import firebase messaging or as needed;
import { Firebase } from '@ionic-native/firebase';

@NgModule({
  imports: [
    HttpClientModule,
    // AngularFireModule.initializeApp(AppSettings.getFirebaseConfig()),
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireStorageModule,
    AngularFireDatabaseModule,
    AngularFireMessagingModule
  ],
  providers: [
    MessageFactory,
    ProfileServiceProvider,
    ApiServiceProvider,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorProvider,
      multi: true
    },
    Firebase,
    FirebaseServiceProvider,
    StorageServiceProvider,
    LocalStorageServiceProvider,
    RequestServiceProvider,
    PaymentServiceProvider,
    BalanceServiceProvider,
    CheckoutServiceProvider,
    ToastServiceProvider,
    LoaderServiceProvider,
    UtilsServiceProvider,
    FacebookServiceProvider,
    ShareServiceProvider,
    FtueServiceProvider,
    InterestsServiceProvider
  ]
})
export class ProvidersModule {}



// WEBPACK FOOTER //
// ./src/providers/providers.module.ts